import React, { useEffect, useRef } from 'react';
import { FILTER_KEYS } from '../../config/constants';
import { useRouter } from '../../helpers/customHooks';
import { useFiltersState } from '../../store/hooks';
import { useHealthDispatch, useHealthState } from '../../store/hooks/health';

import Table, { RowsType } from '../Shared/CustomTable';
import Loader from '../Shared/Loader';

export default () => {
  const { specificScope } = useRouter();
  const {
    [FILTER_KEYS.VENUE]: venue,
    [FILTER_KEYS.TIME_SLIDER]: timeSlider
  } = useFiltersState(specificScope, FILTER_KEYS.VENUE, FILTER_KEYS.TIME_SLIDER);
  const { dPacketsData } = useHealthState();
  const { getDPacketsData, changeMessageNoDaGeneric: noData } = useHealthDispatch();
  const second = useRef(false);
  useEffect(() => {
    if (venue && venue.value && venue.value.siteId ) {
      getDPacketsData(venue.value.siteId, true);
      second.current = true;
    } else {
      noData();
    }
  }, [venue]);
  useEffect(() => {
    if (second.current) {
      if (venue && venue.value && venue.value.siteId  && timeSlider) {
        getDPacketsData(venue.value.siteId, !timeSlider.interval);
      } else {
        noData();
      }
    }
  }, [timeSlider]);
  const headers = [
    { content: 'ID', style: { width: '125px', paddingLeft: '20px' } },
    { content: 'Entity', style: { width: '302px' } },
    { content: 'Level', style: { width: '194px' } },
    { content: 'Time', style: { width: '348px' } },
    { content: 'Type', style: { width: '303px' } }
  ];
  const rows: RowsType<string, number> = [];
  dPacketsData.forEach((data: any) => {
    rows.push({
      columns: [
        { content: data.id, style: { paddingLeft: '20px' } },
        { content: data.event },
        { content: data.level },
        { content: data.time },
        { content: data.type }
      ],
      style: {},
      id: data.id + data.event
    });
  });
  return (
    <Loader style={{ height: 'calc(100vh - 239px)', border: '2px solid rgba(219, 225, 229, 0.6)' }}>
      <div style={{ fontSize: '14px', padding: '10px 20px', textAlign: 'right' }}>{dPacketsData.length} Result(s)</div>
      <div style={{ height: 'calc(100% - 41px' }}>
        <Table
          headers={headers}
          rows={rows}
        />
      </div>
    </Loader>
  );
};
